import {
  Box,
  styled,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  TextField,
  Button,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { nbrBase, nbrHead } from 'src/components/3d/Interface/Customization/Dimension/CustomSteles';
import { useEnv } from 'src/context/EnvProvider';
import useLoadDataList from 'src/hook/useLoadDataList';
import { getAllAssemblies } from 'src/services/assemblies';
import { getGranits } from 'src/services/granits';
import { addStock, CustomStele, GetPiece, getPieces, PieceInAssembly } from 'src/services/stock';
import { handleMutation } from 'src/utils/api.utils';

export const AddSteleStock = () => {
  const { data: granits } = useLoadDataList(getGranits);
  const { buckets } = useEnv();

  const [selectedStele, setSelectedStele] = useState<CustomStele>({
    baseIndex: 0,
    boxDownWidth: 0,
    boxHeight: 0,
    boxLeftHeight: 0,
    boxRightHeight: 0,
    boxUpWidth: 0,
    depth: 0,
    headIndex: 0,
  });
  const [selectedGranitId, setSelectedGranitId] = useState<string>();

  const [quantity, setQuantity] = useState('');
  const [price, setPrice] = useState('');
  const [name, setName] = useState('');

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    if (!selectedStele || !selectedGranitId) return;

    handleMutation(
      (data) => addStock(data),
      {
        name,
        quantity: Number.parseInt(quantity, 10),
        price: Number.parseFloat(price),
        stockSteles: [
          {
            ...selectedStele,
            granitId: selectedGranitId,
          },
        ],
      },
      () => {
        toast.success('Stock ajouté avec succès');
      },
    );
  };

  return (
    <Container>
      <Form onSubmit={handleSubmit}>
        <FormControl fullWidth sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Row>
            <FormControl sx={{ width: '100%' }}>
              <InputLabel id="piece-label">Haut de la stèle</InputLabel>
              <Select
                value={selectedStele.headIndex}
                onChange={(e) =>
                  setSelectedStele({ ...selectedStele, headIndex: Number(e.target.value) })
                }
              >
                {Array.from({ length: nbrHead }).map((_, index) => (
                  <MenuItem key={index} value={index}>
                    Haut {index + 1}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ width: '100%' }}>
              <InputLabel id="piece-label">Bas de la stèle</InputLabel>
              <Select
                value={selectedStele.baseIndex}
                onChange={(e) =>
                  setSelectedStele({ ...selectedStele, baseIndex: Number(e.target.value) })
                }
              >
                {Array.from({ length: nbrBase }).map((_, index) => (
                  <MenuItem key={index} value={index}>
                    Haut {index + 1}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ width: '300px' }}>
              <InputLabel id="granit-label">Choisir un granit</InputLabel>
              <Select
                labelId="granit-label"
                value={selectedGranitId}
                onChange={(e) => setSelectedGranitId(e.target.value)}
                label="Granit"
                required
                renderValue={(value) => {
                  const granit = granits?.find((g) => g.id === value);
                  return granit?.name;
                }}
              >
                {granits?.map((granit) => (
                  <MenuItem
                    key={granit.id}
                    value={granit.id}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2,
                      flexDirection: 'row',
                    }}
                  >
                    {granit.image && (
                      <Box
                        component="img"
                        src={`${buckets?.BUCKET_3D_PIECES || ''}/${granit.image}`}
                        alt={granit.name}
                        sx={{ width: 50, height: 50, objectFit: 'cover' }}
                      />
                    )}
                    <Typography variant="body1">{granit.name}</Typography>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Row>

          <Row>
            <FormControl sx={{ width: '300px' }}>
              <p id="piece-label">Hauteur </p>
              <TextField
                type="string"
                value={
                  selectedStele.boxHeight === 0 ? '' : (selectedStele.boxHeight * 100).toFixed(0)
                }
                onChange={(e) =>
                  setSelectedStele({ ...selectedStele, boxHeight: Number(e.target.value) / 100 })
                }
              />
            </FormControl>
            <FormControl sx={{ width: '300px' }}>
              <p id="piece-label">Hauteur coté droit</p>
              <TextField
                type="string"
                value={
                  selectedStele.boxRightHeight === 0
                    ? ''
                    : (selectedStele.boxRightHeight * 100).toFixed(0)
                }
                onChange={(e) =>
                  setSelectedStele({
                    ...selectedStele,
                    boxRightHeight: Number(e.target.value) / 100,
                  })
                }
              />
            </FormControl>
            <FormControl sx={{ width: '300px' }}>
              <p id="piece-label">Hauteur coté gauche</p>
              <TextField
                type="string"
                value={
                  selectedStele.boxLeftHeight === 0
                    ? ''
                    : (selectedStele.boxLeftHeight * 100).toFixed(0)
                }
                onChange={(e) =>
                  setSelectedStele({
                    ...selectedStele,
                    boxLeftHeight: Number(e.target.value) / 100,
                  })
                }
              />
            </FormControl>
          </Row>
          <Row>
            <FormControl sx={{ width: '300px' }}>
              <p id="piece-label">Largeur</p>
              <TextField
                type="string"
                value={
                  selectedStele.boxUpWidth === 0 ? '' : (selectedStele.boxUpWidth * 100).toFixed(0)
                }
                onChange={(e) =>
                  setSelectedStele({
                    ...selectedStele,
                    boxUpWidth: Number(e.target.value) / 100,
                  })
                }
              />
            </FormControl>
            <FormControl sx={{ width: '300px' }}>
              <p id="piece-label">Largeur pied</p>
              <TextField
                type="string"
                value={
                  selectedStele.boxDownWidth === 0
                    ? ''
                    : (selectedStele.boxDownWidth * 100).toFixed(0)
                }
                onChange={(e) =>
                  setSelectedStele({
                    ...selectedStele,
                    boxDownWidth: Number(e.target.value) / 100,
                  })
                }
              />
            </FormControl>
            <FormControl sx={{ width: '300px' }}>
              <p id="piece-label">Épaisseur</p>
              <TextField
                type="string"
                value={selectedStele.depth === 0 ? '' : (selectedStele.depth * 100).toFixed(0)}
                onChange={(e) =>
                  setSelectedStele({ ...selectedStele, depth: Number(e.target.value) / 100 })
                }
              />
            </FormControl>
          </Row>
        </FormControl>

        <TextField
          fullWidth
          label="Quantité"
          type="number"
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
          required
          inputProps={{ min: 1 }}
        />

        <TextField
          fullWidth
          label="Prix"
          type="number"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          required
          inputProps={{ min: 0, step: 0.01 }}
        />

        <TextField
          fullWidth
          label="Nom"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />

        <Button type="submit" variant="contained" color="primary" fullWidth>
          Ajouter au stock
        </Button>
      </Form>
    </Container>
  );
};

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
});

const Form = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
});

const Row = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
});
